module.exports = __webpack_public_path__ + "img/online.9a1566a1.svg";